import { shallowEqual } from 'react-redux'

import { useEntity } from '@hozana/api/hooks/useEntity'

import type { TPublication } from './types'

export const usePublication = (
  publicationId: number,
  equalityFn = shallowEqual as (left: TPublication, right: TPublication) => boolean,
) => useEntity('publication', publicationId, equalityFn)
